import React from 'react';
import MessageUI from '../../../widgets/output/MessageUI';
import ModalFormUI from '../../../widgets/form/ModalFormUI';
import InputTextSF from '../../../widgets/form/InputTextSF';

const UpdateWhatsappModalUI = ({ 
  context, 
  errorList, 
  successMsg, 
  setErrorList,
  onSubmit, 
  onCancelClick, 
  updatePhoneMode, 
  submitted,
  phone,
  onPhoneChange,
  phoneError,
  setPhoneError
}) => {
  const validatePhone = (value) => {
    if (!value || value.trim() === '') {
      setPhoneError('Phone number is required');
      return false;
    }
    
    if (!/^\+?[0-9\s\-()]{8,15}$/.test(value)) {
      setPhoneError('Please enter a valid phone number');
      return false;
    }
    
    setPhoneError(null);
    return true;
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (validatePhone(phone)) {
      onSubmit();
    }
  };

  return (
    <ModalFormUI
      context={context}
      titleLabel="Update WhatsApp Number"
      buttonLabel={submitted ? "Updating..." : "Update Phone"}
      cancelLabel="Cancel"
      
      isOpen={updatePhoneMode}
      onRequestClose={onCancelClick}
      successMsg={successMsg}
      errorList={errorList}
      setErrorList={setErrorList}
      onSubmit={handleFormSubmit}
      busy={submitted}
    >
      <InputTextSF 
        type="text"
        name="phone"
        label="Phone Number"
        maxLength={15}
        required={true}
        value={phone} 
        onChange={onPhoneChange}
        error={phoneError} 
        setError={setPhoneError}
      />
    </ModalFormUI>
  );
};

export default UpdateWhatsappModalUI;